$(document).ready(function () {
    importationMassiveEquilibrationRoles.initPreChargerImportationMassiveEquilibrationRoles();

    const select = document.getElementById('id_methode_calcul');
    if (select) {
        select.onchange = importationMassiveEquilibrationRoles.gererChangementValeursFormFrontEnd;
        importationMassiveEquilibrationRoles.gererChangementValeursFormFrontEnd();
    }
    const boolNettoyerDonnees = document.getElementById('id_bool_nettoyer_donnees');
    if (boolNettoyerDonnees) {
        boolNettoyerDonnees.onchange = importationMassiveEquilibrationRoles.gererChangementValeursFormFrontEnd;
    }
});

var importationMassiveEquilibrationRoles = (function () {
    const configFileInput = {
        style: 'well',
        btn_choose: 'Cliquez pour sélectionner un fichier de tableur',
        btn_change: null,
        no_icon: 'ace-icon fa fa-cloud-upload',
        droppable: true,
        thumbnail: 'large',
        whitelist: 'xls|xlsx|ods',
        before_change: function (files, dropped) {
            if (dropped && files && files.length > 0) {
                const dataTransfer = new DataTransfer();
                dataTransfer.items.add(files[0]);
                $('#id_fichier')[0].files = dataTransfer.files;
            }
            return true; // Permet de continuer et trigger 'change'
        }
    };

    function initPreChargerImportationMassiveEquilibrationRoles() {
        resetErrorsImportationMassiveEquilibrationRoles();

        setTimeout(function () {
            $('#btn-wizard-suivant-terminer').prop('disabled', true);
        }, 0);

        let nouveauFichier = $('#id_fichier');
        const formulaire = nouveauFichier.closest('form')[0];
        $('#zone-televersement-fichier-erreur').css("display", "none");

        nouveauFichier.off('change');
        nouveauFichier.ace_file_input(configFileInput);

        nouveauFichier.on('change', function () {
            if (this.files && this.files.length > 0) {
                traiterFichierImporte(formulaire);
            }
        });
    }

    function traiterFichierImporte(formulaire) {
        $('#zone-televersement-fichier-erreur .message').html('');
        wait.start();

        const success = function (response) {
            resetErrorsImportationMassiveEquilibrationRoles();
            wait.stop();
        }

        const error = function (response) {
            if (response.responseJSON && response.responseJSON.message) {
                $('#zone-televersement-fichier-erreur .message').html(response.responseJSON.message);
                $('#zone-televersement-fichier-erreur').css("display", "inline");
            } else {
                $('#zone-televersement-fichier-erreur .message').html('Veuillez vous assurer que le fichier n\'est pas ouvert dans une autre application.');
                $('#zone-televersement-fichier-erreur').css("display", "inline");
            }
            wait.stop();
        }

        importationMassiveEquilibrationRoles.saveImportationMassiveEquilibrationRolesEtape1(success, error);
    }

    function resetErrorsImportationMassiveEquilibrationRoles() {
        $('#zone-televersement-fichier-erreur .message').html('');
        $('#zone-televersement-fichier-erreur').css("display", "none");
        $('#btn-wizard-suivant-terminer').prop('disabled', false);
    }

    function saveImportationMassiveEquilibrationRolesEtape1(callback, errorCallback = null) {
        wait.start('contenu');
        resetErrorsImportationMassiveEquilibrationRoles();
        const form = $('#modal-step-contents > .active .form-horizontal');
        let form_data = new FormData();
        let data = form.serializeArray();

        form_data = ajouterParametresImportationMassiveEquilibrationRoles(data, form_data);

        const success = function (xhr) {
            if (typeof (callback) !== 'undefined') {
                $('#btn-wizard-suivant-terminer').prop('disabled', false);
                xhr.reponse = 'ok';
                callback(xhr);
            }

            wait.stop();
        }

        const error = function (xhr) {
            if (errorCallback) {
                errorCallback(xhr);
            } else if (typeof (callback) !== 'undefined') {
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    $('#zone-televersement-fichier-erreur .message').html(xhr.responseJSON.message);
                    $('#zone-televersement-fichier-erreur').css("display", "inline");
                }
                xhr.reponse = 'error';
            }
            $('#btn-wizard-suivant-terminer').prop('disabled', true);
            $('.tooltip').remove();
            wait.stop();
        }

        const url = '/gestion-roles/importation-massive-equilibration-roles/etape1/';
        call_ajax_with_file(url, 'POST', form_data, success, error);
    }

    function initImportationMassiveEquilibrationRolesEtape2() {
        wait.start('contenu');
        const formEtape1 = $('#modal-step-contents > #modal-step1 .form-horizontal');
        let form_data = new FormData();
        let data = formEtape1.serializeArray();

        form_data = ajouterParametresImportationMassiveEquilibrationRoles(data, form_data);
        infos.ajouterMessageToast({
            message: ("Le chargement des données à l'écran peut prendre un certain temps. Ne pas fermer cette fenêtre " +
                "ou appuyer sur terminer tant que les informations ne sont pas affichées."),
            messageDuree: 3000,
        });

        const url = '/gestion-roles/importation-massive-equilibration-roles/etape2/';
        const success = function (response) {
            let etape = $('#modal-step-contents > .active');
            etape.html(response['html']);
            etape.attr('recharger', 'oui');
            if (response['nb_ue_a_updater'] == 0) {
                $('#btn-wizard-suivant-terminer').prop('disabled', true);
            }
            wait.stop('contenu');
        }
        const error = function (xhr) {
            if (xhr.responseJSON) {
                let etape = $('#modal-step-contents > .active');
                etape.html(xhr.responseJSON['html']);
                $('#btn-wizard-suivant-terminer').prop('disabled', true);
            }
            $('.tooltip').remove();
            wait.stop('contenu');
        }

        call_ajax_with_file(url, 'POST', form_data, success, error);
    }

    function saveImportationMassiveEquilibrationRolesEtape2(callback) {

        const formEtape1 = $('#modal-step-contents > #modal-step1 .form-horizontal');
        let form_data = new FormData();
        let data = formEtape1.serializeArray();

        form_data = ajouterParametresImportationMassiveEquilibrationRoles(data, form_data);

        const url = '/gestion-roles/importation-massive-equilibration-roles/etape2/sauvegarde/';
        const success = function (response) {
            response.reponse = 'ok';
            fenetreModal.fermerModal('modal-wizard-evenement');
            infos.ajouterMessageToast({
                message: response.message,
                messageDuree: 3000,
            });
        }

        const error = function (xhr) {
            xhr.reponse = 'error';
            if (xhr.responseJSON && xhr.responseJSON.message) {
                infos.ajouterMessageToast({
                    message: xhr.responseJSON.message,
                    messageCouleur: "red",
                    type: 'error',
                    messageDuree: 0
                });
            } else {
                infos.ajouterMessageToast({
                    message: 'Une erreur est survenue lors de l\'importation massive des rôles.',
                    messageCouleur: "red",
                    messageDuree: 0
                });
            }
            callback(xhr);
        }
        if (form_data.get('bool_nettoyer_donnees')) {
            fenetreModal.modalMessage({
                titre: "",
                taille: "grande",
                sansX: true,
                texteExplicatif: "Voulez-vous vraiment procéder au nettoyage de toutes les entrées existantes du rôle en préparation pour la méthode de calcul et la ou les municipalité(s) sélectionnées ? Cette action est irréversible.",
                boutons: {
                    "Confirmer": {
                        label: " Confirmer ",
                        id: "",
                        class: "btn btn-success",
                        action: function () {
                            call_ajax_with_file(url, 'POST', form_data, success, error);
                        }
                    },
                    "Annuler": {
                        label: " Annuler ",
                        id: "btn-annuler",
                        class: "btn btn-default",
                        action: function () {
                            fenetreModal.fermerModalAlerteDivs();
                            wait.stop('contenu');
                        }
                    }
                }
            });
        } else {
            call_ajax_with_file(url, 'POST', form_data, success, error);
        }
    }

    function ajouterParametresImportationMassiveEquilibrationRoles(data, form_data) {
        for (let idx in data) {
            form_data.append(data[idx].name, data[idx].value);
        }

        const dateInput = $('#id_date_prise_effet');
        if (dateInput.length > 0) {
            form_data.append('date_prise_effet', dateInput.val());
        }

        if (!data.some(item => item.name === 'bool_valeur_retenue')) {
            const valeurRetenue = document.getElementById('id_bool_valeur_retenue').value;
            form_data.append('bool_valeur_retenue', valeurRetenue);
        }

        const fileInput = $('#id_fichier');
        if (fileInput.length > 0 && fileInput[0].files.length > 0) {
            form_data.append(fileInput.attr('name'), fileInput[0].files[0], fileInput[0].files[0].name);
        }
        return form_data;
    }

    function gererChangementValeursFormFrontEnd() {
        const selectMethode = document.getElementById('id_methode_calcul');
        let valeurRetenue = document.getElementById('id_bool_valeur_retenue');
        let boolNettoyerDonnees = document.getElementById('id_bool_nettoyer_donnees');

        // Trigger la validation de fichier si la méthode est changée
        const champMethodeCalcul = $('#id_methode_calcul');

        champMethodeCalcul.on('change', function () {
            traiterFichierImporte()
        });

        const divBoolNettoyerDonnees = $('#div_id_bool_nettoyer_donnees');

        const estMethodeB94 = ['3', '4'].includes(selectMethode.value);

        valeurRetenue.disabled = estMethodeB94;
        boolNettoyerDonnees.disabled = estMethodeB94;

        if (estMethodeB94) {
            valeurRetenue.value = 'True';
            divBoolNettoyerDonnees.css("display", "none");
        } else {
            divBoolNettoyerDonnees.css("display", "block");
        }
    }

    return {
        initPreChargerImportationMassiveEquilibrationRoles: initPreChargerImportationMassiveEquilibrationRoles,
        saveImportationMassiveEquilibrationRolesEtape1: saveImportationMassiveEquilibrationRolesEtape1,
        initImportationMassiveEquilibrationRolesEtape2: initImportationMassiveEquilibrationRolesEtape2,
        saveImportationMassiveEquilibrationRolesEtape2: saveImportationMassiveEquilibrationRolesEtape2,
        gererChangementValeursFormFrontEnd: gererChangementValeursFormFrontEnd,
    }
})
();
